(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seo-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFAQ(section) {
    var detailsNodes = section.querySelectorAll('.seo-faq__item');

    detailsNodes.forEach(function (details) {
      var summary = details.querySelector('.seo-faq__summary');
      if (!summary) return;

      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        if (details.open) {
          detailsNodes.forEach(function (sibling) {
            if (sibling !== details && sibling.open) {
              sibling.open = false;
            }
          });
        }
      });

      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          details.open = !details.open;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="seo-faq"]').forEach(initFAQ);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="seo-faq"]');
    if (section) initFAQ(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
